export default __webpack_public_path__ + "static/media/sdnn-result.3cd00640.svg";